module.exports = __webpack_public_path__ + "img/wizard-map.1016215e.png";